import { TranslationLabels } from "translations/TranslationLabels";

export enum ParticipantStatusEnum {
  Unknown = 0,
  Present = 1,
  Excused = 2,
  Unexcused = 3,
  Deleted = 4,
}

/**
 * Gets the localized label for a ParticipantStatusEnum value.
 */
export function getParticipantStatusLabel(value: ParticipantStatusEnum, i18n: TranslationLabels): string {
  switch (value) {
    case ParticipantStatusEnum.Unknown:
      return i18n.ParticipantStatus_Unknown;
    case ParticipantStatusEnum.Present:
      return i18n.ParticipantStatus_Present;
    case ParticipantStatusEnum.Excused:
      return i18n.ParticipantStatus_Excused;
    case ParticipantStatusEnum.Unexcused:
      return i18n.ParticipantStatus_Unexcused;
    case ParticipantStatusEnum.Deleted:
      return i18n.ParticipantStatus_Deleted;
    default:
      return `Unknown ParticipantStatusEnum: ${value}`;
  }
}
